import React, { createContext, useContext, useState } from "react";

const AdminContext = createContext(null);

function AdminProvider({ children }) {
  const [adminData, setAdminData] = useState({ data: null, token: null });
  return (
    <AdminContext.Provider value={{ adminData, setAdminData }}>
      {children}
    </AdminContext.Provider>
  );
}

export function useAdmin() {
  const context = useContext(AdminContext);

  if (context === undefined) {
    throw new Error("Admin context used outside its provider!");
  }

  return context;
}

export default AdminProvider;
